import React from 'react';

import { useStepper } from '../../../../../shared/hooks/useStepper';
import {
  SetupCustomerStepper,
  StepOption,
} from '../../../../../shared/components/steppers/SetupCustomerStepper/SetupCustomerStepper';
import { PersonalInfoStep } from './PersonalInfoStep/PersonalInfoStep';
import { SelectSubscription } from '../../components/SelectSubscription/SelectSubscription';

const CreateCustomerStep = () => {
  const { activeStep, goToNextStep } = useStepper();

  const stepsConfig: StepOption[] = [
    {
      title: "We couldn't find an account for you",
      description:
        'Please fill in your personal information to create a profile and start your first InBody scan. All fields are required.',
      step: <PersonalInfoStep onCustomerCreated={goToNextStep} />,
    },
    {
      title: 'Select a plan below that fits your needs',
      description: 'Select a subscription and proceed to the checkout with Stripe',
      step: <SelectSubscription />,
    },
  ];

  return (
    <SetupCustomerStepper
      activeStep={activeStep}
      stepsConfig={stepsConfig}
      title="User Form"
    />
  );
};

export { CreateCustomerStep };
